import React, { useEffect, useState } from "react"
import { CardContent, Button, Grid, ImageListItemBar, ImageList, ImageListItem, IconButton } from "@material-ui/core"
import { Cancel } from "@material-ui/icons";

export const ImageOqt = ({data, name, details = false, formik, imgStyle}) => {

  //const error = formik && formik.errors[name];
  //const hasError = Boolean(error);
  const [selectedFile, setSelectedFile] = useState(null)
  const [key, setKey] = useState(() => formik && formik.values[name])  
  const [imageData, setImageData] = useState()

  useEffect(()=>{
    if(key){
      data.keyValues({key}).get().then(response => {
        setImageData(response.value);
      })
    }else{
      setImageData(undefined);
    }
    formik && formik.values[name] !== key && formik.setFieldValue(name, key);
  },[key])

  const handleFileCancel = (event) => {
    setSelectedFile(null);
    data.keyValues({key}).remove();
    setKey(undefined)
  }
  
    // On file select (from the pop up) 
  const onFileChange = (event) => { 
    // Update the state 
    if(event.target.files.length > 0) {
      var reader  = new FileReader();
      reader.onloadend = function () {
        data.keyValues({data: reader.result}).store().then(response => {
          setKey(response.key);
        })
      }
      reader.readAsDataURL(event.target.files[0]);
      setSelectedFile( event.target.files[0] ); 
      event.target.value = [ ];
    }
  }; 
  
  return (
    <div style={{ padding: 8, width: "100%" }}>
      {!selectedFile && !imageData && !details && 
        <CardContent>
          <div> 
            <input 
              type="file" 
              name="imageUpload" 
              id={name}
              style={{display: "none"}} 
              onChange={onFileChange} 
            /> 
              <Button variant="contained" disabled={selectedFile !== null}><label for={name} >Seleccione el archivo de imagen.</label></Button>
          </div> 
        </CardContent>
      }
      {imageData &&
        <Grid container> 
          <Grid item xs={12}>
            <ImageList cols={1}>
              <ImageListItem style={{padding: 16}}>
                <img
                  alt="imagen"
                  src={imageData}
                  style={{padding: 0, minHeight: 60, maxWidth: 140, display:"inline", objectFit: "contain", ...(imgStyle || {})}}
                  draggable={false}
                />  
                <ImageListItemBar 
                  style={{backgroundColor: "rgba(0, 0, 0, 0)"}} 
                  title={!selectedFile ? "" : selectedFile.name} subtitle={!selectedFile ? "" : selectedFile.type} 
                  position="top" 
                  actionIcon={
                    <>
                      {!details && 
                        <IconButton style={{backgroundColor: "rgba(0, 0, 0, 0.28)"}} onClick={handleFileCancel}>
                          <Cancel style={{fill: "#FFFFFF", opacity: 0.8}}/>
                        </IconButton>
                      }
                    </>
                  } 
                />
              </ImageListItem>
            </ImageList>
          </Grid>
        </Grid> 
      }
   </div>
  )
}